import { StyleSheet } from 'react-native';

export const topicItemStyling = theme => {
  return StyleSheet.create({
    itemContainer: {
      flexDirection: 'row',
      gap: 10,
      zIndex: -10,
      marginBottom: 10
    },
    itemContainerItem1: {
      flex: 1.2,
      backgroundColor: theme.palette.primaryBackgroundLow,
      borderRadius: 10,
      paddingVertical: 10,
      paddingHorizontal: 15
    },
    itemContainerItem2: {
      flex: 1,
      borderRadius: 10,
      paddingVertical: 10,
      paddingHorizontal: 15,
      alignItems: 'flex-end'
    }
  });
};
export const topicStyling = theme => {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      flexWrap: 'wrap'
    },
    topicItemHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginVertical: 15
    },
    topicItemContainer: {
      minWidth: '300px',
      flex: 1,
      paddingHorizontal: 20
    },
    topicFirstItemContainer: {
      borderRightWidth: 1,
      borderColor: theme.palette.primaryOutline
    },
    chartContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap'
    },
    chartContainerFooter: {
      flexDirection: 'row',
      justifyContent: 'center',
      marginTop: 20
    },
    chartItem: {
      minWidth: '400px',
      flex: 1,
      padding: 20
    },
    chartFirstItem: {
      borderRightWidth: 1,
      borderColor: 'rgb(206, 212, 218)'
    },
    topicTooltipContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10
    }
  });
};
